import { Flex, Grid, GridItem, Heading, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { DefaultContainer, Image } from '@/shared/ui';
import { getCardsBenefits } from '../lib/cardsBenefits';
import cardsImage from '/public/store-products/landing/cards.png';

const CardsBenefitsBlock = () => {
  const { t } = useTranslation();
  const cardsBenefits = getCardsBenefits(t);

  return (
    <DefaultContainer
      bg={{ base: 'bg.dark', md: 'none' }}
      py={0}
    >
      <Flex
        alignItems='center'
        bg='bg.dark'
        borderRadius='lg'
        flexDir={{ base: 'column', md: 'row' }}
        gap='2xl'
        p={{ base: 0, md: '2xl' }}
      >
        <Image
          alt='Review card benefits'
          h={{ base: '330px', md: '282px', lg: '320px' }}
          imgSizes={{ base: '280px', md: '240px', lg: '275px' }}
          minW={{ base: '280px', md: '240px', lg: '275px' }}
          src={cardsImage}
        />
        <Grid
          gap='xl'
          gridTemplateColumns={{ base: '1fr', md: '1fr 1fr', xl: '1fr 1fr 1fr' }}
        >
          {cardsBenefits?.map(({ title, text }) => (
            <GridItem
              key={title}
              color='white'
              flexDir='column'
            >
              <Heading
                as='h4'
                fontSize={{ base: 'xl', lg: '2xl' }}
              >
                {title}
              </Heading>
              <Text mt={{ base: 'xs', lg: 'sm' }}>{text}</Text>
            </GridItem>
          ))}
        </Grid>
      </Flex>
    </DefaultContainer>
  );
};

export default CardsBenefitsBlock;
